/* ============================================================
   EVAMATS — CRO mobile overlay (config template only, ≤749px)
   Zasada: ZERO zmian w logice konfiguratora (product-config.js /
   product.js / product-form.js). Ten plik tylko:
   - dodaje klasę scope + wstrzykuje elementy prezentacyjne,
   - proxy'uje kliki do istniejących przycisków,
   - czyta stan (klasy .open/.complete, wartości inputów).
   ============================================================ */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 749.98px)');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var product = document.querySelector('.product.config_container');
    if (!product || !MQ.matches) return;
    var info = product.querySelector('.product__info-container');
    if (!info) return;
    /* GUARD: uruchamiamy TYLKO na konfiguratorze dywaników (mat). Produkty na szablonie „config"
       bez pól mat (organizery, body_type „corners"/pusty, itp.) pomijamy, żeby ich NIE zepsuć. */
    if (!product.querySelector('fieldset[data-name="mats_set"], [data-dropdown="mats_set_type"], #rok-produkcji, [data-dropdown="year"]')) return;
    document.documentElement.classList.add('evm-cro');

    /* ---------- helpers ---------- */
    function el(tag, cls, html) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (html != null) e.innerHTML = html;
      return e;
    }
    function evmAssetBase() {
      var sc = Array.prototype.slice.call(document.scripts).find(function (s) { return /evm-cro-mobile\.js/.test(s.src || ''); });
      return sc ? sc.src.replace(/evm-cro-mobile\.js.*$/, '') : '/cdn/shop/t/95/assets/';
    }
    function assetUrl(file) {
      return evmAssetBase() + file;
    }
    function iconImg(file, alt) {
      return '<img class="evm-icon-img" loading="lazy" alt="' + (alt || '') + '" src="' + assetUrl(file) + '">';
    }
    var ICONS = {
      car: iconImg('evm-icon-selected-vehicle.svg', ''),
      chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>',
      factory: iconImg('evm-icon-polish-production.svg', ''),
      factory10: iconImg('evm-icon-production-10-days.svg', ''),
      target: iconImg('evm-icon-car-model.svg', ''),
      drop: iconImg('evm-icon-water-dirt.svg', ''),
      pencil: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4l10-10-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg>',
      truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 7.5h10v8h-10z"/><path d="M13.5 10h3.4l3.6 3.2v2.3h-7z"/><path d="M5.7 17.5a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"/><path d="M15.4 17.5a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"/><path d="M3.5 11h5.2"/></svg>',
      delivery4: iconImg('evm-icon-delivery-4-days.svg', ''),
      check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M8 12.3l2.5 2.5L16.5 9"/></svg>',
      box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7l9-4 9 4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/></svg>'
    };
    function parsePLN(txt) {
      if (!txt) return 0;
      var m = String(txt).replace(/\s|&nbsp;/g, '').match(/(\d+(?:[.,]\d+)?)/);
      return m ? parseFloat(m[1].replace(',', '.')) : 0;
    }

    /* ---------- 1. pasek pojazdu + plakietki ---------- */
    var titleEl = product.querySelector('.product__title h1, h1.product__title, .product__title');
    var rawTitle = titleEl ? (titleEl.textContent || '').trim() : '';
    function toRoman(n) {
      var m = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
      return m[n] || ('' + n);
    }
    function parseVehicle(t) {
      var s = t.replace(/^.*?\bdo\s+/i, '').trim();           // po „…do "
      s = s.replace(/^(EVA\s+)?Dywaniki\b.*?\bdo\s+/i, '').trim();
      var gm = s.match(/^(.+?)\s+(\d{1,2})\s*gen(?:eracja|eracji)?\b/i); // „Marka Model N gen"
      if (gm) return gm[1].trim().replace(/\s+/g, ' ') + ' ' + toRoman(parseInt(gm[2], 10)) + ' gen';
      // bez „gen": utnij rocznik / rok / typ nadwozia — zostaw markę+model (+ ew. kod/gen)
      var base = s
        .replace(/\s*[\(\[].*$/, '')
        .replace(/\s+\d{4}\s*[-–—]\s*\d{2,4}.*$/, '')
        .replace(/\s+\d{4}\+?.*$/, '')
        .replace(/\s+rok\b.*$/i, '')
        .replace(/\s+(SUV|Sedan|Hatchback|Kombi|Coupe|Cabrio|Kabriolet|Roadster|Van|Minivan|Pickup|Bus|Liftback|Fastback|Crossover)\b.*$/i, '')
        .replace(/\s+\d+[-\s]?(drzwiowy|osobowy)\b.*$/i, '')
        .trim();
      return base || s;
    }
    var vehicle = parseVehicle(rawTitle) || rawTitle;
    /* czysty, krótki H1 jak w makiecie */
    var ym = rawTitle.match(/(\d{4})\s*[-–—]\s*(\d{4})/);
    var yearRange = ym ? ym[1] + '–' + ym[2] : '';
    var cleanTitle = 'EVA Dywaniki 3D ' + vehicle + (yearRange ? ' ' + yearRange : '');
    Array.prototype.slice.call(product.querySelectorAll('h1')).forEach(function (h) {
      if (/Dywanik/i.test(h.textContent || '')) h.textContent = cleanTitle;
    });

    var vbar = el('div', 'evm-vehicle',
      '<span class="evm-vehicle__ico">' + ICONS.car + '</span>' +
      '<span class="evm-vehicle__meta"><span class="evm-vehicle__k">Wybrany pojazd</span>' +
      '<span class="evm-vehicle__name"></span></span>' +
      '<button type="button" class="evm-vehicle__change">Zmień auto ' + ICONS.chev + '</button>');
    vbar.querySelector('.evm-vehicle__name').textContent = vehicle;
    function brandCollectionUrl() {
      var brand = (vehicle || rawTitle || '').replace(/\b[IVX]+\s+gen\b.*$/i, '').trim().split(/\s+/)[0] || '';
      var h = brand.toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return h ? ('/collections/' + h) : '/collections';
    }
    function changeVehicle() {
      sessionStorage.setItem('evmReturnSummary', '1');
      window.location.href = brandCollectionUrl();
    }
    vbar.querySelector('.evm-vehicle__change').setAttribute('data-evm-brand-url', brandCollectionUrl());
    vbar.querySelector('.evm-vehicle__change').addEventListener('click', changeVehicle);

    var perks = el('div', 'evm-perks',
      '<div class="evm-perk">' + ICONS.factory + '<span>Produkcja<br>w Polsce</span></div>' +
      '<div class="evm-perk">' + ICONS.target + '<span>Pod model<br>auta</span></div>' +
      '<div class="evm-perk">' + ICONS.drop + '<span>Woda<br>i brud</span></div>');

    var titleWrap = titleEl ? (titleEl.closest('.product__title') || titleEl) : null;
    if (titleWrap && titleWrap.parentNode) {
      titleWrap.parentNode.insertBefore(perks, titleWrap.nextSibling);
      titleWrap.parentNode.insertBefore(vbar, perks);
    } else {
      info.insertBefore(perks, info.firstChild);
      info.insertBefore(vbar, perks);
    }

    /* ---------- 2. sticky tabs ---------- */
    function findSection(sel) {
      var n = document.querySelector(sel);
      return n ? (n.closest('.shopify-section') || n) : null;
    }
    var tabsDef = [
      { label: 'Konfigurator', target: product, tabId: null },
      { label: 'Opis', target: findSection('.product_tabs'), tabId: 'description' },
      { label: 'Dane', target: findSection('.product_tabs'), tabId: 'tech' },
      { label: 'Dostawa', target: findSection('.product_tabs'), tabId: 'delivery' },
      { label: 'Cechy', target: findSection('.image-with-text'), tabId: null },
      { label: 'Akcesoria', target: findSection('.related-products-custom, [class*="related-products-custom"]'), tabId: null },
      { label: 'Opinie', target: findSection('[class*="reputon"], [class*="google-review"], [class*="google_review"], .google-reviews, [data-google-reviews]'), tabId: null }
    ].filter(function (t) { return !!t.target; });
    /* deduplikacja celów (Opis/Dane/Dostawa → jedna sekcja) zostaje: różne tabId */

    var tabsBar = el('nav', 'evm-tabs');
    tabsBar.setAttribute('aria-label', 'Sekcje produktu');
    var spyLock = false, spyLockT = null, activeIdx = 0;
    function setActive(idx) {
      if (idx == null || idx < 0) return;
      activeIdx = idx;
      var btns = tabsBar.children;
      for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('active', i === idx);
      var act = btns[idx];
      if (act) tabsBar.scrollTo({ left: Math.max(0, act.offsetLeft - 40), behavior: prefersReduced() ? 'auto' : 'smooth' });
    }
    /* zwolnij blokadę spy dopiero gdy przewijanie się zatrzyma (nie w trakcie animacji) */
    function releaseLockOnIdle() {
      clearTimeout(spyLockT);
      var idle;
      var onScr = function () { clearTimeout(idle); idle = setTimeout(done, 140); };
      function done() { window.removeEventListener('scroll', onScr); spyLock = false; spy(); }
      window.addEventListener('scroll', onScr, { passive: true });
      idle = setTimeout(done, 650); /* awaryjnie, gdy sekcja już w kadrze i scroll nie startuje */
    }
    tabsDef.forEach(function (t, i) {
      var b = el('button', 'evm-tab' + (i === 0 ? ' active' : ''), t.label);
      b.type = 'button';
      b.addEventListener('click', function () {
        spyLock = true; clearTimeout(spyLockT);
        setActive(i);                                   /* natychmiast podświetl klikniętą */
        if (t.tabId) {
          var item = document.querySelector('.product_tabs__item[data-id="' + t.tabId + '"]');
          if (item) item.click();
        }
        setTimeout(function () {                          /* po ew. przełączeniu wewn. taba przelicz pozycję */
          var top = t.target.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - 8;
          window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced() ? 'auto' : 'smooth' });
          releaseLockOnIdle();                            /* odblokuj spy dopiero po zatrzymaniu scrolla */
        }, t.tabId ? 90 : 0);
      });
      tabsBar.appendChild(b);
    });
    function prefersReduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    function headerH() {
      var h = document.querySelector('.shopify-section-group-header-group .header-wrapper, .section-header, header.header, sticky-header');
      if (!h) return 0;
      var r = h.getBoundingClientRect();
      return (r.top <= 1 && r.bottom > 0) ? r.bottom : 0;
    }
    function tabsOffset() { return headerH() + tabsBar.offsetHeight; }
    function setTabsTop() {
      document.documentElement.style.setProperty('--evm-tabs-top', headerH() + 'px');
      document.documentElement.style.setProperty('--evm-preview-top', (headerH() + (tabsBar ? tabsBar.offsetHeight : 46) + 6) + 'px');
    }
    setTabsTop();
    window.addEventListener('resize', setTabsTop);
    /* wstaw tuż nad sekcją produktu (a nie wewnątrz niej) — wtedy sticky „trzyma" przez CAŁĄ stronę,
       łącznie z opisem/lendingiem, i menu nie znika po zjechaniu z konfiguratora */
    (function () {
      var psec = product.closest('.shopify-section') || product;
      var host = psec.parentNode || product.parentNode;
      host.insertBefore(tabsBar, psec);
    })();

    /* scroll-spy (z obsługą dołu strony — ostatnia sekcja zawsze może być aktywna) */
    var spyTick = false;
    function spy() {
      spyTick = false;
      if (spyLock) return;                               /* nie nadpisuj podczas kliknięcia/scrollu */
      var pos = window.pageYOffset + tabsOffset() + 50;
      var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4;
      /* niezależne od kolejności tabów: sekcja o największym topie ≤ pos = aktualna */
      var current = 0, bestTop = -Infinity;
      tabsDef.forEach(function (t, i) {
        var top = t.target.getBoundingClientRect().top + window.pageYOffset;
        if (top <= pos && top > bestTop) { bestTop = top; current = i; }
      });
      if (atBottom) current = tabsDef.length - 1;
      /* Opis/Dane/Dostawa wskazują tę samą sekcję — nie przeskakuj między pod-tabami, jeśli już w niej jesteśmy */
      if (tabsDef[activeIdx] && tabsDef[current] && tabsDef[activeIdx].target === tabsDef[current].target) return;
      setActive(current);
    }
    window.addEventListener('scroll', function () {
      if (!spyTick) { spyTick = true; window.requestAnimationFrame(spy); }
    }, { passive: true });

    /* ---------- 2c. OPIS → 1:1 z makietą: krótki lede + zgrupowana lista cech z ikonami SVG ---------- */
    (function () {
      var box = document.querySelector('.product_tabs__containers_item[data-id="description"]');
      if (!box || box.dataset.evmOpis) return;
      box.dataset.evmOpis = '1';
      var S = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"';
      var IC = {
        drop: '<svg ' + S + '><path d="M12 2.7S5.5 9.6 5.5 14.3a6.5 6.5 0 0 0 13 0C18.5 9.6 12 2.7 12 2.7z"/></svg>',
        spark: '<svg ' + S + '><path d="M12 3l1.6 4.6L18 9l-4.4 1.4L12 15l-1.6-4.6L6 9l4.4-1.4L12 3z"/><path d="M19 14l.7 2 .3.9-2 .7 2-.7.7-2 .7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" opacity=".5"/></svg>',
        leaf: '<svg ' + S + '><path d="M11 20A7 7 0 0 1 4 13c0-5 4.5-9 16-9 0 8-4 16-9 16z"/><path d="M8 17c2-4 5-6 9-8"/></svg>',
        ruler: '<svg ' + S + '><rect x="2.5" y="8.5" width="19" height="7" rx="1.5"/><path d="M7 8.5v3M11 8.5v4M15 8.5v3M19 8.5v4"/></svg>',
        thermo: '<svg ' + S + '><path d="M10 13.5V5a2 2 0 0 1 4 0v8.5a4 4 0 1 1-4 0z"/></svg>'
      };
      var model = (typeof vehicle === 'string' && vehicle) ? vehicle : 'Twój model';
      var feats = [
        { i: IC.drop, t: '100% odporność na wilgoć', d: 'Woda i błoto zostają w komórkach, nie na podłodze.' },
        { i: IC.spark, t: 'Czyszczenie w kilka sekund', d: 'Wystarczy wytrzepać lub spłukać wodą.' },
        { i: IC.leaf, t: 'Bezpieczne dla zdrowia i zwierząt', d: 'Materiał EVA bez zapachu, w 100% z recyklingu.' },
        { i: IC.ruler, t: 'Dopasowanie do 95% podłogi', d: 'Wykrój przygotowany 1:1 pod ' + model + '.' },
        { i: IC.thermo, t: 'Odporność −50°C do +50°C', d: 'Nie twardnieją zimą, nie odkształcają się latem.' }
      ];
      box.innerHTML =
        '<p class="evm-opis-lede">Oryginalne dywaniki <b>EVAMATS</b> — nowoczesna ochrona wnętrza auta. Wykrój przygotowany pod konkretny model, struktura komórkowa zatrzymuje błoto, piasek i wodę, a obszycie chroni tapicerkę wzdłuż każdej linii.</p>' +
        '<div class="evm-feat-list">' + feats.map(function (f) {
          return '<div class="evm-feat"><span class="evm-f-ic">' + f.i + '</span><div class="evm-f-tx"><div class="evm-f-t">' + f.t + '</div><div class="evm-f-d">' + f.d + '</div></div></div>';
        }).join('') + '</div>';
    })();

    /* ---------- 2d. DOSTAWA I PŁATNOŚĆ → stara treść + tylko GLS/Pickup cleanup ---------- */
	    (function () {
	      var box = document.querySelector('.product_tabs__containers_item[data-id="delivery"]');
      if (!box || box.dataset.evmDelv) return;
      box.dataset.evmDelv = '1';
      var GLS_LOGO = 'https://cdn.shopify.com/s/files/1/0790/9218/7414/files/GLS_Logo_2021_svg.svg?v=1774966899';
      Array.prototype.slice.call(box.querySelectorAll('li, p, div')).forEach(function (node) {
        var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
        var smallRow = node.tagName === 'LI' || (node.children.length === 0 && t.length < 140);
        if (smallRow && /Paczkomat\s+InPost|Punkt\s+odbioru\s+DPD\s+Pickup/i.test(t)) node.remove();
      });
      Array.prototype.slice.call(box.querySelectorAll('ul, ol, p, div')).forEach(function (node) {
        if (!node.textContent.trim() && !node.querySelector('img, svg, iframe, video')) node.remove();
      });
      Array.prototype.slice.call(box.querySelectorAll('strong, b, span, p, li, div')).forEach(function (node) {
        var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (t === 'GLS' && !node.querySelector('img')) {
          node.innerHTML = '<img class="evm-gls-logo" src="' + GLS_LOGO + '" alt="GLS" loading="lazy">';
        }
      });
	    })();

	    /* ---------- 2e. Product tabs: 3 widoczne przyciski na telefonie ---------- */
	    (function () {
	      var short = { description: 'Opis', tech: 'Dane', delivery: 'Dostawa' };
	      Array.prototype.slice.call(document.querySelectorAll('.product_tabs__item')).forEach(function (item) {
	        var id = item.getAttribute('data-id');
	        if (short[id]) item.textContent = short[id];
	      });
	    })();

	    /* ---------- 3. kroki: opisy rodzaju + kolejność stanów ---------- */
    var typeFs = product.querySelector('fieldset[data-name="mats_type"]');
    if (typeFs) {
      typeFs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var lab = typeFs.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        var v = (inp.dataset.title || inp.value || '').toLowerCase();
        if (v.indexOf('bez rant') > -1) lab.setAttribute('data-evm-desc', 'Lekka ochrona na co dzień');
        else if (v.indexOf('rantami') > -1 || v.indexOf('3d') > -1) lab.setAttribute('data-evm-desc', 'Lepsza ochrona przed wodą i błotem');
      });
      function cleanOfferBadges() {
        Array.prototype.slice.call(typeFs.querySelectorAll('.label_oferta')).forEach(function (badge) {
          if (badge.dataset.evmClean === '1') return;
          badge.dataset.evmClean = '1';
          badge.textContent = 'POLECANE';
          badge.classList.add('evm-offer-badge');
        });
      }
      cleanOfferBadges();
      new MutationObserver(cleanOfferBadges).observe(typeFs, { childList: true, subtree: true });
    }

    /* w sekcji istnieją ukryte duplikaty (desktop) — bierzemy tylko widoczne,
       po jednym na data-dropdown */
    function visibleWrappers() {
      var seen = {};
      return Array.prototype.slice.call(product.querySelectorAll('.product__dropdown_wr'))
        .filter(function (w) {
          if (w.classList.contains('evm-summary')) return false;
          if (!w.offsetParent) return false; /* ukryty (także przez rodzica) */
          var k = w.getAttribute('data-dropdown') || w.className;
          if (seen[k]) return false;
          seen[k] = true;
          return true;
        });
    }
    var wrappers = visibleWrappers();
    var required = wrappers.filter(function (w) {
      return w.querySelector('input[required], select[required], textarea[required]');
    });

    /* numeracja: badge z data-num; tekstowe "N." (dodawane przez motyw) zdejmujemy */
    function stripNumText(t) {
      var n = t.firstChild;
      while (n && n.nodeType === 3 && !n.nodeValue.trim()) n = n.nextSibling;
      if (n && n.nodeType === 3) n.nodeValue = n.nodeValue.replace(/^\s*\d+\.\s*/, '');
    }
    wrappers.forEach(function (w, i) {
      var t = w.querySelector('.product__dropdown_title');
      if (!t) return;
      t.setAttribute('data-num', i + 1);
      stripNumText(t);
      new MutationObserver(function () { stripNumText(t); }).observe(t, { childList: true });
    });

    /* ---------- WIZARD (prezentacyjnie; logika kroków bez zmian) ---------- */
	    var STEP_TOTAL = wrappers.length;
	    var progress = el('div', 'evm-progress',
	      '<span class="evm-progress__pill">Krok 1 z ' + STEP_TOTAL + '</span>' +
	      '<span class="evm-progress__bar">' + new Array(STEP_TOTAL + 1).join('<i></i>') + '</span>');
	    function actionLabelFor(w, idx) {
	      return 'Dalej';
	    }
	    function decorateActionButton(btn, label) {
	      if (!btn || btn.dataset.evmActionLabel === label) return;
	      btn.dataset.evmActionLabel = label;
	      btn.innerHTML = '<span class="evm-btn-label">' + label + '</span><span class="evm-btn-arrow">' + ICONS.chev + '</span>';
	      btn.setAttribute('aria-label', label);
	    }
	    if (wrappers[0] && wrappers[0].parentNode) {
	      wrappers[0].parentNode.insertBefore(progress, wrappers[0]);
	    }
    function configScrollExtra(w) {
      return 16;
    }
    function scrollToConfig() {
      var active = openWrapper() || firstUnpassed();
      var top = progress.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - configScrollExtra(active);
      window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced() ? 'auto' : 'smooth' });
    }
    /* pomocnicze: kliknięcie tytułu (native triggerFaq) mimo pointer-events */
    function clickTitle(w) {
      var t = w && w.querySelector('.product__dropdown_title');
      if (!t) return;
      t.style.pointerEvents = 'auto'; t.click(); t.style.pointerEvents = '';
    }
    /* Wstecz w każdym kroku poza pierwszym; własne Dalej tam, gdzie motyw go nie ma
       (podpiętki/akcesoria — kroki opcjonalne) */
    wrappers.forEach(function (w, i) {
      if (w.querySelector('.evm-back')) return;
      var inner = w.querySelector('.product__dropdown_inner');
      if (!inner) return;
      var dalej = inner.querySelector('.product__dropdown_button');
      var navRow = el('div', 'evm-nav-row');
      if (i > 0) {
        var back = el('button', 'evm-back', ICONS.chev + ' Wstecz');
        back.type = 'button';
        back.addEventListener('click', function (e) {
          e.preventDefault();
          clickTitle(wrappers[i - 1]);
          scrollToConfig();
        });
        navRow.appendChild(back);
      }
	      if (dalej) {
	        inner.insertBefore(navRow, dalej);
	        navRow.appendChild(dalej);
	        decorateActionButton(dalej, actionLabelFor(w, i));
	      } else {
	        /* krok opcjonalny bez natywnego Dalej → przycisk prezentacyjny */
	        var nx = el('button', 'evm-next');
	        nx.type = 'button';
	        decorateActionButton(nx, actionLabelFor(w, i));
	        nx.addEventListener('click', function (e) {
          e.preventDefault();
          w.classList.add('evm-passed'); /* krok opcjonalny przeklikany */
          if (editReturn || i === wrappers.length - 1) {
            editReturn = false;
            clickTitle(w); /* zamknij — brak otwartych → podsumowanie */
            setTimeout(function () {
              syncAll();
              var top = summary.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - 10;
              window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced() ? 'auto' : 'smooth' });
            }, 60);
          } else {
            clickTitle(wrappers[i + 1]); /* otwiera następny, zamyka bieżący */
            setTimeout(function () { syncAll(); scrollToConfig(); }, 60);
          }
        });
        navRow.appendChild(nx);
        inner.appendChild(navRow);
      }
      if (!navRow.childNodes.length) navRow.remove();
    });

    /* ---------- kroki opcjonalne: „Opcjonalne" pill + tekst + Polecane(EVA) + notka ---------- */
    function evmOptionalDecor() {
      wrappers.forEach(function (w) {
        var title = w.querySelector('.product__dropdown_title');
        if (!title) return;
        var txt = title.textContent || '';
        var isHeel = /podpi[eę]t/i.test(txt);
        var isExtras = /dodatkow/i.test(txt) || w.getAttribute('data-dropdown') === 'extras';
        if (!isHeel && !isExtras) return;
        /* „(opcjonalnie)" z tytułu → pokazujemy jako pill */
        Array.prototype.slice.call(title.childNodes).forEach(function (n) {
          if (n.nodeType === 3 && /opcjonaln/i.test(n.nodeValue)) {
            n.nodeValue = n.nodeValue.replace(/\s*\(\s*opcjonaln\w*\s*\)\s*/i, ' ').replace(/\s+([:：])/, '$1');
          }
        });
        if (!title.querySelector('.evm-opt-pill')) title.appendChild(el('span', 'evm-opt-pill', 'Opcjonalne'));
        var inner = w.querySelector('.product__dropdown_inner');
        if (!inner) return;
        if (isHeel) {
          if (!inner.querySelector('.evm-step-lead')) {
            inner.insertBefore(el('p', 'evm-step-lead',
              'Dodatkowa nakładka tam, gdzie <b>dywanik ściera się najszybciej</b> — pod piętą kierowcy.'), inner.firstChild);
          }
          if (!inner.querySelector('.evm-rec-tag')) {
            var cand = Array.prototype.slice.call(inner.querySelectorAll('a, label, strong, b, .option__title, span, p'));
            for (var i = 0; i < cand.length; i++) {
              var c = cand[i], ct = (c.textContent || '').trim();
              if (ct.length < 42 && /\bEVA\b/i.test(ct) && !c.querySelector('*')) {
                c.insertAdjacentElement('afterend', el('span', 'evm-rec-tag', 'Polecane')); break;
              }
            }
          }
        }
        if (isExtras && !inner.querySelector('.evm-step-note')) {
          inner.insertBefore(el('div', 'evm-step-note',
            '<svg viewBox="0 0 24 24" fill="none" stroke="#1E9E5A" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
            '<span>Wszystko poniżej jest <b>opcjonalne</b>. Możesz nic nie dodawać i od razu przejść do koszyka.</span>'),
            inner.firstChild);
        }
      });
    }
    var evmDecorT;
    function evmOptionalDecorSoon() { clearTimeout(evmDecorT); evmDecorT = setTimeout(evmOptionalDecor, 150); }
    [0, 250, 700, 1500, 3000, 5000].forEach(function (d) { setTimeout(evmOptionalDecor, d); });
    new MutationObserver(evmOptionalDecorSoon).observe(product, { childList: true, subtree: true });

    function syncProgress() {
      var open = openWrapper();
      var done = reachedSummary();
      var fu = firstUnpassed();
      var idx = open ? wrappers.indexOf(open) : (done ? STEP_TOTAL : (fu ? wrappers.indexOf(fu) : 0));
      var pill = progress.querySelector('.evm-progress__pill');
      pill.textContent = done ? 'Podsumowanie' : ('Krok ' + (Math.min(idx, STEP_TOTAL - 1) + 1) + ' z ' + STEP_TOTAL);
      var segs = progress.querySelectorAll('.evm-progress__bar i');
      for (var i = 0; i < segs.length; i++) {
        segs[i].classList.toggle('done', done || stepPassed(wrappers[i]) || i < idx);
      }
    }
    /* zabezpieczenie: nigdy nie zostawiaj pustego widoku (otwórz pierwszy nieprzejdziony) */
    function wizardGuard() {
      if (openWrapper()) return;
      if (!reachedSummary()) {
        var w = firstUnpassed();
        var t = w && w.querySelector('.product__dropdown_title');
        if (t) { t.style.pointerEvents = 'auto'; t.click(); t.style.pointerEvents = ''; }
      }
    }
    document.documentElement.classList.add('evm-wizard');
    var STEP_NAMES = {
      year: 'Wybierz rok',
      mats_set_type: 'Wybierz zestaw',
      mat_patterns_colors: 'Wybierz kolory',
      heel: 'Podpiętki',
      extras: 'Akcesoria'
    };
    function stepKey(w) {
      return w.getAttribute('data-dropdown') || (w.className.indexOf('--heel') > -1 ? 'heel' : 'extras');
    }
    function allRequiredDone() {
      return required.every(function (w) { return w.classList.contains('complete'); });
    }
    function openWrapper() {
      return wrappers.find(function (w) { return w.classList.contains('open'); }) || null;
    }
    function firstIncomplete() {
      return required.find(function (w) { return !w.classList.contains('complete'); }) || null;
    }
    /* „przejdziony" = wymagany ukończony (complete) LUB opcjonalny przeklikany (evm-passed).
       Podsumowanie / ATC pokazujemy dopiero po WSZYSTKICH 5 krokach. */
    function stepPassed(w) { return w.classList.contains('complete') || w.classList.contains('evm-passed'); }
    function firstUnpassed() { return wrappers.find(function (w) { return !stepPassed(w); }) || null; }
    function reachedSummary() { return wrappers.every(stepPassed) && !openWrapper(); }
    function yearChosen() { var y = product.querySelector('#rok-produkcji'); return !!(y && y.value); }

    /* ---------- 4. sticky buybar ---------- */
    var sticky = product.querySelector('.sticky_container');
    var stickyBtn = sticky ? sticky.querySelector('.sticky_add_to_cart') : null;
    var priceSrc = sticky ? sticky.querySelector('.sticky_config_price_price') : null;
    var evmMainPriceNode = null;
    function evmMoney(txt) {
      var m = String(txt || '').replace(/\s+/g, ' ').match(/(\d+(?:[.,]\d+)?)/);
      return m ? Math.round(parseFloat(m[1].replace(',', '.'))) : null;
    }
    function evmSelectedSetPriceParts() {
      var checked = product.querySelector('fieldset[data-name="mats_set"] input[type="radio"]:checked');
      var label = checked && (checked.closest('label') || product.querySelector('label[for="' + checked.id + '"]'));
      var nowEl = label && label.querySelector('.evm-set-price b');
      var oldEl = label && label.querySelector('.evm-set-price s');
      var now = evmMoney(nowEl ? nowEl.textContent : '');
      var old = evmMoney(oldEl ? oldEl.textContent : '');
      if (now == null && priceSrc) now = evmMoney(priceSrc.textContent);
      if (old != null && now != null && old <= now) old = null;
      return { now: now, old: old };
    }
    function evmRenderMainPrice() {
      var box = product.querySelector('.main_price') || document.querySelector('.main_price');
      if (!box) return;
      var host = box.parentNode || box;
      if (!evmMainPriceNode) {
        evmMainPriceNode = document.querySelector('.evm-main-price-custom') || el('div', 'evm-main-price-custom', '');
      }
      if (evmMainPriceNode.parentNode !== host || evmMainPriceNode.nextSibling !== box) host.insertBefore(evmMainPriceNode, box);
      var parts = evmSelectedSetPriceParts();
      if (!parts.now) {
        evmMainPriceNode.innerHTML = '';
        return;
      }
      var html = '<span class="evm-main-now">' + parts.now + ' zł</span>';
      if (parts.old) {
        var pct = Math.round((1 - (parts.now / parts.old)) * 100);
        html += '<span class="evm-main-old">' + parts.old + ' zł</span>';
        if (pct > 0) html += '<span class="evm-main-pct">-' + pct + '%</span>';
      }
      if (evmMainPriceNode.innerHTML !== html) evmMainPriceNode.innerHTML = html;
    }
    [0, 80, 250, 700, 1400, 2800, 4800].forEach(function (delay) {
      setTimeout(evmRenderMainPrice, delay);
    });
    document.addEventListener('change', function () { setTimeout(evmRenderMainPrice, 35); }, true);
    var evmPriceTicks = 0;
    var evmPriceTimer = setInterval(function () {
      evmPriceTicks += 1;
      evmRenderMainPrice();
      if (evmPriceTicks > 24 && document.querySelector('.evm-main-price-custom')) clearInterval(evmPriceTimer);
    }, 500);
    new MutationObserver(function () { setTimeout(evmRenderMainPrice, 25); })
      .observe(document.body, { childList: true, subtree: true });
    var bbMeta, bbPrice, bbStep, bbLabel;
    if (sticky && stickyBtn) {
      bbMeta = el('div', 'evm-bb-meta',
        '<div class="evm-bb-price"><span class="evm-bb-now"></span><s class="evm-bb-old"></s></div>');
      bbPrice = bbMeta.querySelector('.evm-bb-now');
      sticky.insertBefore(bbMeta, stickyBtn);
      bbStep = el('span', 'evm-bb-step', '');
      sticky.insertBefore(bbStep, stickyBtn);
      bbLabel = el('span', 'evm-bb-label', 'Dalej');
      stickyBtn.insertBefore(bbLabel, stickyBtn.firstChild);
      stickyBtn.insertBefore(el('span', 'evm-bb-arrow', ICONS.chev), bbLabel.nextSibling);
      stickyBtn.setAttribute('aria-label', 'Dalej');

      stickyBtn.addEventListener('click', function (e) {
        if (reachedSummary()) {            /* gotowe → dodaj do koszyka (ukryty submit) */
          e.preventDefault(); e.stopImmediatePropagation();
          addToCart();
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        var w = openWrapper() || firstUnpassed();
        if (!w) return;
        if (!w.classList.contains('open')) {
          var t = w.querySelector('.product__dropdown_title');
          if (t) t.click();
        } else {
          var nx = w.querySelector('.evm-next');       /* kroki opcjonalne (podpiętki/akcesoria): własny Dalej = advance+scroll */
          if (nx) { nx.click(); return; }
          var btn = w.querySelector('.product__dropdown_button');
          if (btn) btn.click();
        }
        var top = w.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - configScrollExtra(w);
        window.scrollTo({ top: top, behavior: prefersReduced() ? 'auto' : 'smooth' });
      }, true);
      /* przenieś buybar bezpośrednio do <body> — żeby fixed bottom:0 był PRZY dole ekranu
         (jakiś przodek z transform/filter „więził" go i zostawał odstęp/plesz pod paskiem) */
      if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
    }

    function syncBuybar() {
      if (!bbPrice) return;
      var cur = (priceSrc ? priceSrc.textContent.trim() : '') || '';
      bbPrice.textContent = cur;
      var oldEl = bbMeta.querySelector('.evm-bb-old');
      var selectedOld = product.querySelector('fieldset[data-name="mats_set"] input[type="radio"]:checked + label .evm-set-price s');
      if (oldEl) oldEl.textContent = selectedOld ? (selectedOld.textContent || '').trim() : '';
      var open = openWrapper();
      var atEnd = reachedSummary();
      stickyBtn.classList.toggle('evm-is-atc', atEnd); /* koszyk-ikona tylko w podsumowaniu */
	      if (atEnd) {
	        bbStep.textContent = 'Gotowe';
	        bbLabel.textContent = 'Dodaj do koszyka';
	      } else {
	        var w = open || firstUnpassed();
	        var key = w ? stepKey(w) : 'year';
	        var idx = w ? (wrappers.indexOf(w) + 1) : 1;
	        bbStep.textContent = 'Krok ' + idx + '/' + wrappers.length;
	        bbLabel.textContent = actionLabelFor(w, idx - 1);
	      }
	    }

    /* ---------- 5. adaptacyjna darmowa dostawa (600 zł) ---------- */
    var FREE_AT = 600;
    var ship = product.querySelector('.label_delivery');
    var shipBar, shipTxt, shipIcon;
    if (ship) {
      shipIcon = el('span', 'evm-ship-ico', ICONS.truck);
      shipTxt = el('span', 'evm-ship-txt', ship.textContent.trim());
      ship.textContent = '';
      ship.appendChild(shipIcon);
      ship.appendChild(shipTxt);
      shipBar = el('span', 'evm-ship-bar', '<i></i>');
      ship.appendChild(shipBar);
    }
    function currentTotal() {
      var t = parsePLN(priceSrc && priceSrc.textContent);
      if (!t) t = parsePLN((product.querySelector('.option__price_regular') || {}).textContent);
      return t;
    }
    function syncShip() {
      if (!ship) return;
      var total = currentTotal();
      if (!total) return;
      if (total >= FREE_AT) {
        ship.classList.add('evm-free');
        if (shipIcon) shipIcon.innerHTML = ICONS.check;
        shipTxt.innerHTML = '<span class="evm-ship-h">Darmowa dostawa od ' + FREE_AT + ' zł</span>' +
          '<span class="evm-ship-s">Twój zestaw kwalifikuje się do darmowej dostawy</span>';
      } else {
        ship.classList.remove('evm-free');
        if (shipIcon) shipIcon.innerHTML = ICONS.truck;
        shipTxt.innerHTML = '<span class="evm-ship-h">Darmowa dostawa od ' + FREE_AT + ' zł</span>' +
          '<span class="evm-ship-s">Brakuje jeszcze ' + Math.ceil(FREE_AT - total) + ' zł do darmowej wysyłki</span>';
      }
      shipBar.firstChild.style.width = Math.min(100, Math.round(total / FREE_AT * 100)) + '%';
    }

    /* ---------- 5b. „Produkt wykonywany..." → plakietki produkcja/dostawa ---------- */
    (function () {
      var nodes = Array.prototype.slice.call(product.querySelectorAll('p, div'))
        .filter(function (n) {
          return n.children.length <= 2 && /Produkt wykonywany na zamówienie/i.test(n.textContent || '') && (n.textContent || '').length < 220;
        });
      var target = nodes[nodes.length - 1];
      if (!target) return;
      var chips = el('div', 'evm-process',
        '<div class="evm-proc"><span class="evm-proc__ico">' + ICONS.factory10 + '</span>' +
        '<span><span class="evm-proc__k">Produkcja</span><span class="evm-proc__v">do <b>10</b> dni</span></span></div>' +
        '<div class="evm-proc"><span class="evm-proc__ico">' + ICONS.delivery4 + '</span>' +
        '<span><span class="evm-proc__k">Dostawa</span><span class="evm-proc__v">do <b>4</b> dni</span></span></div>');
      target.replaceWith(chips);
    })();

    /* ---------- 6. Podsumowanie ---------- */
    var summary = el('div', 'evm-summary');
    summary.innerHTML =
      '<div class="product__dropdown_title evm-summary__title">Podsumowanie</div>' +
      '<div class="evm-summary__rows"></div>';
    var lastWrapper = wrappers[wrappers.length - 1];
    if (lastWrapper && lastWrapper.parentNode) {
      lastWrapper.parentNode.insertBefore(summary, lastWrapper.nextSibling);
    }
    summary.style.display = 'none';
    var editReturn = false;

    function checkedLabelImg(fieldsetSel, inputSel) {
      /* preferuj WIDOCZNY fieldset (w DOM są ukryte duplikaty) */
      var scopes = Array.prototype.slice.call(product.querySelectorAll(fieldsetSel));
      scopes.sort(function (a, b) { return (b.offsetParent ? 1 : 0) - (a.offsetParent ? 1 : 0); });
      for (var i = 0; i < scopes.length; i++) {
        var scope = scopes[i];
        var inp = scope.querySelector(inputSel + ':checked');
        if (!inp) continue;
        var lab = inp.closest('label') ||
          (inp.id ? scope.querySelector('label[for="' + inp.id + '"]') : null) ||
          (inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL' ? inp.nextElementSibling : null);
        var img = lab ? lab.querySelector('img') : null;
        var src = img ? (img.currentSrc || img.src || img.getAttribute('data-src') || '') : '';
        return { img: src, txt: inp.dataset.title || inp.value || '' };
      }
      return { img: '', txt: '' };
    }
    function rowHTML(icon, imgSrc, k, v, editKey, extraImg) {
      return '<div class="evm-sum-row">' +
        '<span class="evm-sum-fig">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="">' : icon || '') +
        (extraImg ? '<img class="evm-sum-fig__extra" src="' + extraImg + '" alt="">' : '') +
        '</span>' +
        '<span class="evm-sum-txt"><span class="evm-sum-k">' + k + '</span><span class="evm-sum-v">' + v + '</span></span>' +
        (editKey ? '<button type="button" class="evm-sum-edit" data-edit="' + editKey + '">Zmień ' + ICONS.pencil + '</button>' : '') +
        '</div>';
    }
    function buildSummary() {
      var rows = '';
      var yearSel = product.querySelector('#rok-produkcji');
      var year = yearSel && yearSel.value ? yearSel.value : '';
      rows += rowHTML(ICONS.car, '', 'Samochód', vehicle + (year ? ' · ' + year : ''), '');

      var typeInfo = checkedLabelImg('fieldset[data-name="mats_type"]', 'input[type="radio"]');
      var setInfo = checkedLabelImg('fieldset[data-name="mats_set"]', 'input[type="radio"]');
      rows += rowHTML('', setInfo.img || typeInfo.img, 'Zestaw',
        (typeInfo.txt ? typeInfo.txt + ' · ' : '') + (setInfo.txt || '—'), 'mats_set_type');

      var patInfo = checkedLabelImg('fieldset[data-type="matPattern"]', 'input[type="radio"]');
      rows += rowHTML('', patInfo.img, 'Kształt komórek', patInfo.txt || '—', 'mat_patterns_colors');

      var matInfo = checkedLabelImg('fieldset[data-type="matColor"]', 'input[type="radio"]');
      var trimInfo = checkedLabelImg('fieldset[data-type="trimColor"]', 'input[type="radio"]');
      rows += rowHTML('', matInfo.img, 'Kolory (materiał / obszycie)',
        (matInfo.txt || '—') + ' / ' + (trimInfo.txt || '—'), 'mat_patterns_colors', trimInfo.img);

      function itemInfo(c) {
        var it = c.closest('.product__upsell_item, .product__extras_item');
        var img = it && it.querySelector('.product__upsell_image, img');
        var t = it && it.querySelector('.product__upsell_item_title');
        var pr = it && it.querySelector('.product__upsell_price');
        return {
          img: img ? (img.currentSrc || img.src) : '',
          name: (t ? t.textContent.trim() : (c.dataset.title || 'Pozycja')),
          price: pr ? pr.textContent.trim() : ''
        };
      }
      var heelChecked = Array.prototype.slice.call(product.querySelectorAll('input[name="product__upsell"]:checked'));
      heelChecked.forEach(function (c) {                 /* bez wyboru → w ogóle nie pokazuj wiersza podpiętek */
        var f = itemInfo(c);
        rows += rowHTML(ICONS.target, f.img, 'Podpiętka', f.name + (f.price ? ' · ' + f.price : ''), 'heel');
      });

      var exChecked = Array.prototype.slice.call(product.querySelectorAll('input[name="product__extras"]:checked'));
      exChecked.forEach(function (c) {
        var f = itemInfo(c);
        rows += rowHTML(ICONS.box, f.img, 'Akcesorium', f.name + (f.price ? ' · ' + f.price : ''), 'extras');
      });
      summary.querySelector('.evm-summary__rows').innerHTML = rows;
    }
    summary.addEventListener('click', function (e) {
      var b = e.target.closest('.evm-sum-edit');
      if (!b) return;
      var key = b.getAttribute('data-edit');
      if (key === 'year') { changeVehicle(); return; }   /* „Zmień" auta → wybór marki/modelu, nie tylko rok */
      var w = wrappers.find(function (x) { return stepKey(x) === key; }) ||
              product.querySelector('.product__dropdown_wr[data-dropdown="' + key + '"]');
      if (!w) return;
      editReturn = true;
      if (!w.classList.contains('open')) {
        var t = w.querySelector('.product__dropdown_title');
        if (t) t.click();
      }
      var top = w.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - configScrollExtra(w);
      window.scrollTo({ top: top, behavior: prefersReduced() ? 'auto' : 'smooth' });
    });

    /* po Dalej: w trybie edycji wróć do podsumowania; zawsze przewiń do góry kroku */
    product.addEventListener('click', function (e) {
      var dalej = e.target.closest('.product__dropdown_button');
      if (!dalej) return;
      setTimeout(function () {
        if (editReturn) {
          editReturn = false;
          var open = openWrapper();
          if (open) {
            var t = open.querySelector('.product__dropdown_title');
            if (t) { t.style.pointerEvents = 'auto'; t.click(); t.style.pointerEvents = ''; }
          }
        }
        syncAll();
        var openNow = openWrapper();
        if (openNow) {
          scrollToConfig();
        } else {
          var top = summary.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - 10;
          window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced() ? 'auto' : 'smooth' });
        }
      }, 80);
    });

    function syncSummary() {
      var show = reachedSummary(); /* wizard: podsumowanie dopiero po WSZYSTKICH krokach */
      summary.style.display = show ? '' : 'none';
      if (show) {
        buildSummary();
        var atc = summary.querySelector('.evm-sum-atc');
        if (atc) atc.textContent = 'Dodaj do koszyka · ' + (priceSrc ? priceSrc.textContent.trim() : '');
      }
    }

    /* wyróżnij samo ostrzeżenie w landing-content jako osobną kartę */
    Array.prototype.slice.call(document.querySelectorAll('.image-with-text__text')).forEach(function (box) {
      if (box.dataset.evmWarningWrapped) return;
      var nodes = Array.prototype.slice.call(box.childNodes);
      var start = nodes.findIndex(function (n) {
        return ((n.textContent || '').toLowerCase().indexOf('uwaga') > -1);
      });
      if (start < 0) return;
      var card = el('div', 'evm-warning-card', '');
      box.insertBefore(card, nodes[start]);
      for (var i = start; i < nodes.length; i++) card.appendChild(nodes[i]);
      box.dataset.evmWarningWrapped = '1';
    });

    /* ========== 8. FUNKCJE MAKIETY ========== */

    /* 8a. natywny podgląd → statyczna karta w konfiguratorze (przeniesiony poza ukryte kroki) */
    function openLightbox(src) {
      if (!src) return;
      var lb = el('div', 'evm-lightbox',
        '<div class="evm-lightbox__in"><button class="evm-lightbox__x" aria-label="Zamknij">&times;</button><img src="' + src + '" alt="Podgląd dywanika"></div>');
      lb.addEventListener('click', function () { lb.remove(); });
      document.body.appendChild(lb);
    }
    var nativePreview = product.querySelector('.product__config_image--main.product__config_image--mobile');
    var lastPreviewImg = '';
    if (nativePreview && progress && progress.parentNode) {
      nativePreview.classList.add('evm-preview');
      progress.parentNode.insertBefore(nativePreview, progress.nextSibling);
      /* RODZAJ: gdy jest tylko jeden typ mat (brak wyboru) → ukryj chip „Rodzaj", wyśrodkuj Zestaw */
      function evmSingleType() {
        var tfs = product.querySelector('fieldset[data-name="mats_type"]');
        var n = tfs ? tfs.querySelectorAll('input[type="radio"]').length : 0;
        document.documentElement.classList.toggle('evm-single-type', n <= 1);
      }
      [0, 300, 900, 2000].forEach(function (d) { setTimeout(evmSingleType, d); });
	      var pvMeta = nativePreview.querySelector('.product__config_image_selected_value_wr');
	      if (pvMeta && !pvMeta.querySelector('.evm-pv-note')) {
	        var setValue = pvMeta.querySelector('[data-name="mats_set"]');
	        if (!pvMeta.querySelector('[data-type="matPattern"]')) {
	          var patValue = el('div', 'product__config_image_selected_value evm-pv-pattern', '<span></span>');
	          patValue.setAttribute('data-type', 'matPattern');
	          if (setValue && setValue.nextSibling) pvMeta.insertBefore(patValue, setValue.nextSibling);
	          else pvMeta.appendChild(patValue);
	        }
	        var pvExpand = el('button', 'evm-pv-expand', 'Powiększ podgląd');
	        pvExpand.type = 'button';
	        pvExpand.addEventListener('click', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	          nativePreview.classList.toggle('evm-preview-expanded');
	          pvExpand.textContent = nativePreview.classList.contains('evm-preview-expanded') ? 'Zmniejsz podgląd' : 'Powiększ podgląd';
	        });
	        pvMeta.appendChild(pvExpand);
	        pvMeta.appendChild(el('div', 'evm-pv-note', '*Podgląd poglądowy — nie jest zdjęciem gotowego produktu. Dokładny kolor wybierasz poniżej.'));
	      }
      var pvImg = nativePreview.querySelector('.product__config_image--mobile_image');
      if (pvImg) {
        var zoom = el('button', 'evm-pv-zoom', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg>');
        zoom.type = 'button';
        var doZoom = function (e) { e.preventDefault(); e.stopPropagation(); openLightbox(pvImg.currentSrc || pvImg.src); };
        zoom.addEventListener('click', doZoom);
        pvImg.style.cursor = 'zoom-in';
        pvImg.addEventListener('click', doZoom);
        if (pvImg.parentNode) {
          var wrap = el('span', 'evm-pv-imgwrap');
          pvImg.parentNode.insertBefore(wrap, pvImg);
          wrap.appendChild(pvImg);
          wrap.appendChild(zoom);
        }
      }
    }

    /* 8b. plakietki produkcja/dostawa → na górę (nad progress) */
    var procEl = product.querySelector('.evm-process');
    if (procEl && progress && progress.parentNode) progress.parentNode.insertBefore(procEl, progress);

    /* 8c. darmowa dostawa → pod konfigurator (widoczna przy podsumowaniu) */
    if (ship && summary && summary.parentNode) {
      var shipWrap = el('div', 'evm-ship-outer');
      shipWrap.appendChild(ship);
      summary.parentNode.insertBefore(shipWrap, summary.nextSibling);
    }

    /* 8d. Popularne pary kolorów + „Dostosuj kolory" */
    (function () {
      var colorsStep = product.querySelector('.product__dropdown_wr[data-dropdown="mat_patterns_colors"]');
      if (!colorsStep) return;
      var matFs = colorsStep.querySelector('fieldset[data-type="matColor"]');
      if (!matFs) return;
      var PAIRS = [
        { n: 'Czarny + Czarny', mat: 'black', trim: 'black', mh: '#16181c', th: '#16181c' },
        { n: 'Czarny + Czerwony', mat: 'black', trim: 'red', mh: '#16181c', th: '#d4143a' },
        { n: 'Czarny + Niebieski', mat: 'black', trim: 'blue', mh: '#16181c', th: '#2257d6' },
        { n: 'Czarny + Beżowy', mat: 'black', trim: 'beige', mh: '#16181c', th: '#cbb39a' }
      ];
      function setColor(type, dv) {
        /* ustaw we WSZYSTKICH pasujących fieldsetach (są ukryte duplikaty desktop/mobile) */
        var inps = colorsStep.querySelectorAll('fieldset[data-type="' + type + '"] input[data-value="' + dv + '"]');
        Array.prototype.forEach.call(inps, function (inp) {
          if (!inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }
      var pairsWrap = el('div', 'evm-pairs-wrap',
        '<div class="evm-pairs-lab">Popularne pary kolorów <span>TOP</span></div><div class="evm-pairs"></div>');
      var pairsRow = pairsWrap.querySelector('.evm-pairs');
      PAIRS.forEach(function (p) {
        var b = el('button', 'evm-pair',
          '<span class="evm-pair__duo"><i style="background:' + p.mh + '"></i><i style="background:' + p.th + '"></i></span><span class="evm-pair__n">' + p.n + '</span>');
        b.type = 'button';
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(pairsRow.children, function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          setColor('matColor', p.mat); setColor('trimColor', p.trim); setTimeout(syncAll, 60);
        });
        pairsRow.appendChild(b);
      });
      /* domyślnie zaznaczona pierwsza para (Czarny + Czarny) — TOP */
      if (pairsRow.firstChild) { pairsRow.firstChild.classList.add('on'); setColor('matColor', PAIRS[0].mat); setColor('trimColor', PAIRS[0].trim); }
      var toggle = el('button', 'evm-colors-toggle',
        '<span>Dostosuj kolory materiału i obszycia</span>' + ICONS.chev);
      toggle.type = 'button';
      toggle.addEventListener('click', function () {
        colorsStep.classList.toggle('evm-colors-open');
        toggle.classList.toggle('open');
      });
      matFs.parentNode.insertBefore(pairsWrap, matFs);
      matFs.parentNode.insertBefore(toggle, matFs);
      colorsStep.classList.add('evm-has-pairs');
    })();

    /* 8e. ceny per-zestaw (wg wybranego RODZAJU) + nazwy + bestseller + sort */
    (function () {
      var setFs = product.querySelector('fieldset[data-name="mats_set"]');
      var typeFs = product.querySelector('fieldset[data-name="mats_type"]');
      if (!setFs) return;
      var setPos = parseInt(setFs.getAttribute('data-option-position') || '0', 10);
      var typePos = typeFs ? parseInt(typeFs.getAttribute('data-option-position') || '0', 10) : 0;
      var vjson = null;
      var sc = product.querySelector('variant-radios script[type="application/json"]');
      try { vjson = JSON.parse(sc.textContent); } catch (e) { }
      if (!vjson || !setPos) return;
      function currentType() { var t = typeFs && typeFs.querySelector('input:checked'); return t ? t.value : null; }
      function priceFor(setVal) {          /* min cena wariantu: dany zestaw + AKTUALNY rodzaj */
        var tv = currentType(), min = null;
        vjson.forEach(function (v) {
          if (v['option' + setPos] !== setVal) return;
          if (typePos && tv != null && v['option' + typePos] !== tv) return;
          var pr = (v.price || 0) / 100;
          if (min == null || pr < min) min = pr;
        });
        return min;
      }
	      function niceSet(val) {
	        /* USER EDIT GUIDE:
	           Text for Zestaw cards.
	           name = bold title, sub = grey subtitle.
	           Leave sub empty ('') when no grey subtitle should be shown. */
	        var v = (val || '').toLowerCase();
	        var p = /prz[oó]d/.test(v), t = /ty[łl]/.test(v), b = /baga/.test(v), k = /kierowc/.test(v), r3 = /3\s*r(z[ąa]d|z[ęe]dy)/.test(v);
	        if (/ca[łl]e auto/.test(v)) return { name: 'Całe auto + ' + (/du[żz]y/.test(v) ? 'duży' : 'mały') + ' bagażnik', sub: '3 rzędy + bagażnik' };
	        if (/du[żz]a mata/.test(v) && b) return { name: 'Duża mata bagażnika', sub: 'sam bagażnik' };
	        if (/bez\s*tunel/.test(v)) return { name: 'Przód — bez tunelu', sub: '' };
	        if (/z\s*tunel/.test(v)) return { name: 'Przód — z tunelem', sub: '' };
	        var r1o = /^\s*1\s*rz[ąa]d/.test(v), r2o = /^\s*2\s*rz[ęe]d/.test(v), r3o = /^\s*3\s*rz[ęe]d/.test(v);
	        if (r1o && b) return { name: '1 rząd + bagażnik', sub: 'kabina + przestrzeń' };
	        if (r1o) return { name: '1 rząd', sub: 'przód / kabina' };
	        if (r2o && b) return { name: '2 rzędy + bagażnik', sub: '' };
	        if (r2o) return { name: '2 rzędy', sub: '' };
	        if (r3o && b) return { name: '3 rzędy + ' + (/du[żz]y/.test(v) ? 'duży' : 'mały') + ' bagażnik', sub: '' };
	        if (r3o) return { name: '3 rzędy', sub: 'całe wnętrze' };
	        if (/baga[żz]nik\s*ma[łl]y/.test(v)) return { name: 'Bagażnik mały', sub: '' };
	        if (/baga[żz]nik\s*du[żz]y/.test(v)) return { name: 'Bagażnik duży', sub: '' };
	        if (r3 && /2\s*baga/.test(v)) return { name: '3 rzędy + 2 bagażniki', sub: 'Duży + mały bagażnik' };
	        if (p && t && r3 && b) return { name: /du[żz]y/.test(v) ? '3 rzędy + duży bagażnik' : (/ma[łl]y/.test(v) ? '3 rzędy + mały bagażnik' : '3 rzędy + bagażnik'), sub: '' };
	        if (p && t && r3) return { name: '3 rzędy', sub: 'Bez maty bagażnika' };
	        if (p && t && b) return { name: /du[żz]y/.test(v) ? 'Przód + tył + duży bagażnik' : 'Przód + tył + bagażnik', sub: '4 dywaniki + mata bagażnika' };
	        if (p && t) return { name: 'Przód + tył', sub: '4 dywaniki' };
	        if (b && !p && !t) return { name: 'Mata do bagażnika', sub: 'Sam bagażnik' };
	        if (k) return { name: 'Dywanik kierowcy', sub: '1 szt' };
	        if (p && !t) return { name: 'Dywaniki przód', sub: '2 szt' };
	        if (t && !p) return { name: 'Dywaniki tył', sub: 'Listwa tylna' };
	        return { name: val, sub: '' };
	      }
	      function currentBodyType() {
	        var raw = (product.getAttribute('data-type') || '').toLowerCase().trim();
	        if (['bus','bus_solid','van_duzy','van_duzy_solid','van_duzy_separate','van_duzy_solid_2_row','van_duzy_separate_2_row','minivan','minivan_mini','pickup','pickup2kabina','van_maly','tractor','camper','2os','tir','electro','electro_7os'].indexOf(raw) > -1) return raw;
	        var picked = product.querySelector('[data-dropdown="year"] input[name="properties[Typ nadwozia]"]:checked');
	        if (picked) raw = (picked.getAttribute('data-body-type') || picked.value || raw).toLowerCase();
	        if (raw.indexOf('7os') > -1) return '7os';
	        return '5os';
	      }
      var setImgBase = evmAssetBase();
	      var setImages = {
	        /* USER EDIT GUIDE:
	           Images used in Zestaw cards. Change only filenames here when swapping icons.
	           Files must exist in Shopify assets and locally in assets/. */
	        '5os': {
	          front: 'evm-set-5os-front-row.svg',
	          rear: 'evm-set-5os-rear-row.svg',
	          frontRear: 'evm-set-5os-front-rear.svg',
	          trunk: 'evm-set-5os-trunk.svg',
	          frontTrunk: 'evm-set-5os-front-trunk.svg',
	          frontRearTrunk: 'evm-set-5os-front-rear-trunk.svg'
	        },
	        '7os': {
	          front: 'evm-set-7os-front-row.svg',
	          rear: 'evm-set-7os-second-row.svg',
	          frontRear: 'evm-set-7os-front-second.svg',
	          rows123: 'evm-set-7os-front-second-third.svg',
	          trunk: 'evm-set-7os-large-trunk.svg',
	          frontRearTrunk: 'evm-set-7os-front-second-large-trunk.svg',
	          rows123Trunk: 'evm-set-7os-all-rows-trunk.svg',
	          rows123LargeTrunk: 'evm-set-7os-all-rows-large-trunk-v2.svg',
	          rows123TwoTrunks: 'evm-set-7os-all-rows-two-trunks.svg'
	        },
	        bus: { kierowca:'evm-set-box-kierowca-razdz.svg', '1rz':'evm-set-box-1rz-razdz.svg', '2rz':'evm-set-box-2rz-razdz.svg', '3rz':'evm-set-box-3rz-razdz.svg', '3rzDuzyBag':'evm-set-box-3rz-duzybag-razdz.svg', '3rzMalyBag':'evm-set-box-3rz-malybag-razdz.svg', '2rzBag':'evm-set-box-2rz-bag-razdz.svg', '1rzBag':'evm-set-van-1rz-bag-razdz.svg', duzyBag:'evm-set-box-duzybag-razdz.svg', malyBag:'evm-set-box-malybag-razdz.svg' },
	        bus_solid: { '1rz':'evm-set-box-1rz-celny.svg', '2rz':'evm-set-box-2rz-celny.svg', '3rz':'evm-set-box-3rz-celny.svg', '3rzDuzyBag':'evm-set-box-3rz-duzybag-celny.svg', '3rzMalyBag':'evm-set-box-3rz-malybag-celny.svg', '2rzBag':'evm-set-box-2rz-bag-celny.svg', '1rzBag':'evm-set-box-1rz-bag-celny.svg', duzyBag:'evm-set-box-duzybag-celny.svg' },
	        van_duzy_separate: { kierowca:'evm-set-box-kierowca-razdz.svg', '1rz':'evm-set-box-1rz-razdz.svg', '1rzBag':'evm-set-van-1rz-bag-razdz.svg', '2rz':'evm-set-box-2rz-razdz.svg', '2rzBag':'evm-set-box-2rz-bag-razdz.svg', duzyBag:'evm-set-van-duzybag.svg' },
	        van_duzy_solid: { '1rz':'evm-set-box-1rz-celny.svg', '1rzBag':'evm-set-box-1rz-bag-celny.svg', '2rz':'evm-set-box-2rz-celny.svg', '2rzBag':'evm-set-box-2rz-bag-celny.svg', duzyBag:'evm-set-box-duzybag-celny.svg' }
	      };
	      setImages.van_duzy_separate_2_row = setImages.van_duzy_separate;
	      setImages.van_duzy_solid_2_row = setImages.van_duzy_solid;
	      setImages.van_duzy = setImages.van_duzy_separate;
	      setImages.minivan = { kierowca:'evm-set-minivan-kierowca.svg', przod:'evm-set-minivan-przod.svg', '2rz':'evm-set-minivan-2rz.svg', '3rz':'evm-set-minivan-3rz.svg', malybag:'evm-set-minivan-malybag.svg', duzybag:'evm-set-minivan-duzybag.svg', '3rz-malybag':'evm-set-minivan-3rz-malybag.svg', '3rz-duzybag':'evm-set-minivan-3rz-duzybag.svg', '3rz-2bag':'evm-set-minivan-3rz-2bag.svg' };
	      setImages.minivan_mini = setImages.minivan;
	      setImages.pickup = { kierowca:'evm-set-pickup-kierowca.svg', przod:'evm-set-pickup-przod.svg', tyl:'evm-set-pickup-tyl.svg', przodtyl:'evm-set-pickup-przodtyl.svg', bagaznik:'evm-set-pickup-bagaznik.svg', 'przod-bagaznik':'evm-set-pickup-przod-bagaznik.svg', 'przodtyl-bagaznik':'evm-set-pickup-przodtyl-bagaznik.svg' };
	      setImages.pickup2kabina = setImages.pickup;
	      setImages.van_maly = { kierowca:'evm-set-van_maly-kierowca.svg', przod:'evm-set-van_maly-przod.svg', bagaznik:'evm-set-van_maly-bagaznik.svg', 'przod-bagaznik':'evm-set-van_maly-przod-bagaznik.svg' };
	      setImages.tractor = { '1rz':'evm-set-tractor-1rz.svg' };
	      setImages.camper = { '1rz':'evm-set-box-1rz-celny.svg' };
	      setImages['2os'] = { front:'evm-set-5os-front-row.svg', rear:'evm-set-5os-rear-row.svg', frontRear:'evm-set-5os-front-rear.svg', trunk:'evm-set-5os-trunk.svg', frontTrunk:'evm-set-2os-przod-bagaznik.svg', frontRearTrunk:'evm-set-5os-front-rear-trunk.svg' };
	      setImages['7os'].kierowca = 'evm-set-7os-kierowca.svg';
	      setImages.electro_7os = {}; for (var _ek in setImages['7os']) { setImages.electro_7os[_ek] = setImages['7os'][_ek]; } setImages.electro_7os['caleauto-malybag'] = 'evm-set-electro_7os-caleauto-malybag.svg'; setImages.electro_7os['caleauto-duzybag'] = 'evm-set-electro_7os-caleauto-duzybag.svg';
	      setImages.tir = { kierowca:'evm-set-tir-kierowca.svg', 'bez-tunelu':'evm-set-tir-bez-tunelu.svg', 'z-tunelem':'evm-set-tir-z-tunelem.svg' };
	      setImages.electro = { front:'evm-set-5os-front-row.svg', rear:'evm-set-5os-rear-row.svg', frontRear:'evm-set-5os-front-rear.svg', trunk:'evm-set-5os-trunk.svg', frontTrunk:'evm-set-5os-front-trunk.svg', frontRearTrunk:'evm-set-5os-front-rear-trunk.svg', frunk3:'evm-set-electro_7os-caleauto-duzybag.svg' };
	      function setImageKey(val, body) {
	        var v = (val || '').toLowerCase();
	        var p = /prz[oó]d/.test(v), t = /ty[łl]/.test(v), b = /baga/.test(v), k = /kierowc/.test(v), r3 = /3\s*r(z[ąa]d|z[ęe]dy)/.test(v);
	        if (/^(bus|van_duzy)/.test(body)) { var r1 = /1\s*rz[ąa]d/.test(v) || /kabina/.test(v) || (p && !t && !/rz[ęe]d/.test(v)); var r2 = /2\s*rz[ęe]d/.test(v); var duzy = /du[żz]y/.test(v) || /ca[łl]e auto/.test(v); if (k) return 'kierowca'; if (r3 && b) return duzy ? '3rzDuzyBag' : '3rzMalyBag'; if (r3) return '3rz'; if (r2 && b) return '2rzBag'; if (r2) return '2rz'; if (r1 && b) return '1rzBag'; if (r1) return '1rz'; if (b) return (duzy || !/ma[łl]y/.test(v)) ? 'duzyBag' : 'malyBag'; return '1rz'; }
	        if (body === 'electro_7os' && b && /ca[łl]e auto|wszyst|3\s*baga/.test(v)) return /du[żz]y/.test(v) ? 'caleauto-duzybag' : 'caleauto-malybag';
	        if (/minivan/.test(body)) { var mvr2=/2\s*rz[ęe]d/.test(v), mvr3=/3\s*rz[ęe]d/.test(v), mvmaly=/ma[łl]y/.test(v); if (k) return 'kierowca'; if (mvr3 && /2\s*baga/.test(v)) return '3rz-2bag'; if (mvr3 && b) return mvmaly ? '3rz-malybag' : '3rz-duzybag'; if (mvr3) return '3rz'; if (mvr2) return '2rz'; if (b) return mvmaly ? 'malybag' : 'duzybag'; return 'przod'; }
	        if (/pickup/.test(body)) { if (k) return 'kierowca'; if (p && t && b) return 'przodtyl-bagaznik'; if (p && t) return 'przodtyl'; if (p && b) return 'przod-bagaznik'; if (b && !p && !t) return 'bagaznik'; if (t && !p) return 'tyl'; return 'przod'; }
	        if (/van_maly/.test(body)) { if (k) return 'kierowca'; if (p && b) return 'przod-bagaznik'; if (b) return 'bagaznik'; return 'przod'; }
	        if (/tractor|camper/.test(body)) return '1rz';
	        if (body === 'tir') { if (k) return 'kierowca'; if (/bez\s*tunel/.test(v)) return 'bez-tunelu'; if (/tunel/.test(v)) return 'z-tunelem'; return 'kierowca'; }
	        if (body === 'electro' && /3\s*baga/.test(v)) return 'frunk3';
	        if (body === '7os' || body === 'electro_7os') {
	          if (k) return 'kierowca';
	          /* USER EDIT GUIDE:
	             Matching order matters: the most specific 7os sets must stay above the general ones. */
	          if (r3 && /2\s*baga/.test(v)) return 'rows123TwoTrunks';
	          if (p && t && r3 && b && /du[żz]y/.test(v)) return 'rows123LargeTrunk';
	          if (p && t && r3 && b) return 'rows123Trunk';
	          if (p && t && r3) return 'rows123';
	          if (p && t && b) return 'frontRearTrunk';
	          if (p && t) return 'frontRear';
	          if (b) return 'trunk';
	          if (t) return 'rear';
	          return 'front';
	        }
	        if (p && t && b) return 'frontRearTrunk';
	        if (p && b) return 'frontTrunk';
	        if (p && t) return 'frontRear';
	        if (b && !p && !t) return 'trunk';
	        if (t && !p) return 'rear';
	        if (k || p) return 'front';
	        return 'frontRear';
	      }
	      function preferredSetRank(x) {
	        var v = (x.inp.value || x.inp.dataset.title || '').toLowerCase();
	        var isFrontRearBigTrunk = /prz[oó]d/.test(v) && /ty[łl]/.test(v) && /baga/.test(v) && /du[żz]y/.test(v) && !/3\s*r(z[ąa]d|z[ęe]dy)/.test(v);
	        return isFrontRearBigTrunk ? 1 : 0;
	      }
	      function applySetImages() {
	        var cur = currentBodyType();
	        var bodies = (cur === '5os' || cur === '7os') ? ['5os', '7os'] : [cur];
	        bodies.forEach(function (body) {
	          if (!setImages[body]) return;
	          list.forEach(function (x) {
	            var key = setImageKey(x.inp.value || x.inp.dataset.title, body);
	            var file = setImages[body] && setImages[body][key];
	            if (!file) return;
	            var url = setImgBase + file;
	            var img = x.lab.querySelector('img');
	            if (!img) return;
	            img.setAttribute('data-image-' + body, url);
	            if (body === currentBodyType()) img.setAttribute('src', url);
	          });
	        });
	      }
	      var list = [];
      setFs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var lab = inp.closest('label') || setFs.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        list.push({ inp: inp, lab: lab });
        var tip = lab.querySelector('.label__tooltip');
        if (tip && !tip.querySelector('.evm-set-name')) {
          var nm = niceSet(inp.dataset.title || inp.value);
          tip.innerHTML = '<span class="evm-set-name">' + nm.name + '</span>' + (nm.sub ? '<span class="evm-set-sub">' + nm.sub + '</span>' : '');
        }
        if (!lab.querySelector('.evm-set-price')) lab.appendChild(el('span', 'evm-set-price', ''));
      });
	      /* Rabat wg tabeli z template config:
	         290-900 zł → -20%, od 910 zł → -30%.
	         Dzięki temu „z rantami" 1210 zł pokazuje 847 zł, a nie 968 zł. */
	      function discountRatioFor(catalogPrice) {
	        if (catalogPrice >= 910) return 0.7;
	        if (catalogPrice >= 290) return 0.8;
	        return 1;
	      }
	      function recompute() {
	        list.forEach(function (x) {
	          var pr = priceFor(x.inp.value); x.pr = pr;   /* cena KATALOGOWA (stała dla danej opcji) */
	          var pe = x.lab.querySelector('.evm-set-price');
	          if (!pe) return;
	          if (pr == null) { pe.innerHTML = ''; return; }
	          var ratio = discountRatioFor(pr);
	          var now = Math.round(pr * ratio);           /* cena po rabacie = to, co w koszyku */
	          pe.innerHTML = '<b>' + now + ' zł</b>' + (ratio < 1 ? '<s>' + Math.round(pr) + ' zł</s>' : ''); /* przekreślona tylko przy realnym rabacie */
	        });
	      }
      recompute();
	      applySetImages();
		      var maxX = list.slice().sort(function (a, b) { return preferredSetRank(b) - preferredSetRank(a) || (b.pr || 0) - (a.pr || 0); })[0];
		      if (maxX && !maxX.lab.querySelector('.evm-bestseller')) {
		        maxX.lab.insertBefore(el('span', 'evm-bestseller', 'Najczęściej wybierany'), maxX.lab.firstChild);
		      }
		      list.slice().sort(function (a, b) { return preferredSetRank(b) - preferredSetRank(a) || (b.pr || 0) - (a.pr || 0); })
		        .forEach(function (x) { setFs.appendChild(x.inp); setFs.appendChild(x.lab); });
	      function pickDefaultDriverMat() {
	        if (/[?&]variant=/.test(location.search)) return;
	        var wantedType = typeFs && Array.prototype.slice.call(typeFs.querySelectorAll('input[type="radio"]')).find(function (inp) {
	          return /3d\s+bez\s+rant/i.test(inp.value || inp.dataset.title || '');
	        });
	        var wantedSet = list.find(function (x) {
	          return /kierowc/i.test(x.inp.value || x.inp.dataset.title || '');
	        });
	        if (wantedType && !wantedType.checked) {
	          wantedType.checked = true;
	          wantedType.dispatchEvent(new Event('change', { bubbles: true }));
	        }
	        if (wantedSet && !wantedSet.inp.checked) {
	          wantedSet.inp.checked = true;
	          wantedSet.inp.dispatchEvent(new Event('change', { bubbles: true }));
	        }
	      }
	      pickDefaultDriverMat();
	      setTimeout(pickDefaultDriverMat, 500);
	      /* ceny per-opcja = katalog(dla AKTUALNEGO rodzaju) × stały rabat → przeliczamy przy zmianie rodzaju/zestawu
	         (żeby przy „z rantami" ceny rosły) — bez skakania, bo rabat jest stały */
		      if (typeFs) typeFs.addEventListener('change', function () { setTimeout(function () { recompute(); applySetImages(); }, 20); });
	      setFs.addEventListener('change', function () { setTimeout(function () { recompute(); applySetImages(); }, 20); });
	      document.addEventListener('change', function (e) {
	        if (e.target && e.target.matches('[data-dropdown="year"] input[name="properties[Typ nadwozia]"]')) setTimeout(applySetImages, 30);
	      }, true);
	      document.addEventListener('evamats:discount-updated', function () { setTimeout(function () { recompute(); applySetImages(); }, 40); });
	      [400, 1200, 2600].forEach(function (d) { setTimeout(function () { recompute(); applySetImages(); }, d); });
	    })();

    /* 8f. ATC + Wstecz na karcie podsumowania */
    (function () {
      var realSubmit = product.querySelector('.product-form__submit');
      var foot = el('div', 'evm-sum-foot');
      var back = el('button', 'evm-back evm-sum-back', ICONS.chev + ' Wstecz'); back.type = 'button';
      back.addEventListener('click', function () { clickTitle(wrappers[wrappers.length - 1]); scrollToConfig(); });
      var atc = el('button', 'evm-sum-atc', 'Dodaj do koszyka'); atc.type = 'button';
      atc.addEventListener('click', function () { if (realSubmit) realSubmit.click(); });
      foot.appendChild(back); foot.appendChild(atc);
      summary.appendChild(foot);
    })();

	    /* 8i. Cross-sell tylko dla config mobile: stare użycia sekcji zostają nietknięte */
	    (function () {
	      setTimeout(function () {
	        var xsell = document.querySelector('.related-products-custom, [class*="related-products-custom"], [class*="related_products_custom"]');
	        if (!xsell || xsell.dataset.evmXsell) return;
	        var grid = xsell.querySelector('ul.product-grid, ul.related-products__list, ul.grid.product-grid, ul.grid');
	        if (!grid) return;
	        xsell.dataset.evmXsell = '1';

	        var head = xsell.querySelector('h2, .related-products__heading');
	        if (head && !head.querySelector('.evm-xhead__ico')) {
	          head.classList.add('evm-xhead');
	          head.insertBefore(el('span', 'evm-xhead__ico', ICONS.box), head.firstChild);
	        }

	        var cats = [
	          { n: 'Popularne', h: null },
	          { n: 'Ochrona', h: 'cro-ochrona' },
	          { n: 'Organizery', h: 'cro-organizery' }
	        ];
	        var nativeHTML = grid.innerHTML;
	        function readNativeProducts() {
	          grid.innerHTML = nativeHTML;
	          function compactPrice(txt) {
	            var s = String(txt || '').replace(/\s+/g, ' ').trim();
	            var od = /\bOd\b/i.test(s);
	            var matches = s.match(/\d+(?:[,.]\d{2})?\s*zł/g) || [];
	            if (!matches.length) return s;
	            return (od ? 'Od ' : '') + matches[matches.length - 1];
	          }
	          return Array.prototype.slice.call(grid.querySelectorAll('li.grid__item, li')).map(function (li) {
	            var a = li.querySelector('a[href*="/products/"]');
	            var img = li.querySelector('img');
	            var title = (li.querySelector('.card__heading, .full-unstyled-link, a[href*="/products/"]') || a || li).textContent || '';
	            var price = (li.querySelector('.price, .price-item, [class*="price"]') || {}).textContent || '';
	            var variantInput = li.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"][value]');
	            return {
	              href: a ? a.getAttribute('href') : '',
	              title: title.replace(/\s+/g, ' ').trim(),
	              image: img ? (img.currentSrc || img.src || img.getAttribute('src')) : '',
	              priceText: compactPrice(price),
	              variantId: variantInput ? variantInput.value : ''
	            };
	          }).filter(function (p) { return p.href && p.title; });
	        }
	        var nativeProducts = readNativeProducts();
	        var cache = {};
	        var active = 0;
	        var expanded = false;
	        var more = el('button', 'evm-xmore', 'Pokaż więcej ' + ICONS.chev);
	        more.type = 'button';
	        more.addEventListener('click', function () {
	          expanded = !expanded;
	          select(active, true);
	        });
	        var bar = el('div', 'evm-xcats');

	        function esc(s) {
	          return String(s || '').replace(/[&<>"']/g, function (c) {
	            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
	          });
	        }
	        function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : (Math.round(n) + ' zł'); }
	        function syncMore(total) {
	          if (total > 4) {
	            more.innerHTML = (expanded ? 'Pokaż mniej' : 'Pokaż więcej') + ' ' + ICONS.chev;
	            if (more.parentNode !== xsell) xsell.appendChild(more);
	          } else if (more.parentNode) {
	            more.parentNode.removeChild(more);
	          }
	        }
	        function restoreNative() {
	          render(nativeProducts);
	        }
	        function render(products) {
	          grid.classList.remove('evm-xnative');
	          grid.classList.add('evm-xgrid');
	          if (!products || !products.length) {
	            grid.innerHTML = '<li class="evm-xempty">Brak produktów w tej kategorii.</li>';
	            syncMore(0);
	            return;
	          }
	          grid.innerHTML = products.slice(0, expanded ? products.length : 4).map(function (p) {
	            var im = p.image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || p.featured_image || '';
	            var pr = p.priceText || money((p.variants && p.variants[0] && p.variants[0].price) || p.price || '');
	            var href = p.href || ('/products/' + (p.handle || ''));
	            var variantId = p.variantId || (p.variants && p.variants[0] && p.variants[0].id) || '';
	            var btnHref = variantId ? ('/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=1') : href;
	            return '<li class="grid__item evm-xli"><article class="evm-xcard">' +
	              '<a class="evm-xcard__link" href="' + esc(href) + '">' +
	              '<span class="evm-xcard__img">' + (im ? '<img loading="lazy" alt="" src="' + esc(im) + '">' : '') + '</span>' +
	              '<span class="evm-xcard__body"><span class="evm-xcard__t">' + esc(p.title) + '</span>' +
	              '<span class="evm-xcard__p">' + esc(pr) + '</span></span></a>' +
	              '<a class="evm-xcard__btn" href="' + esc(btnHref) + '">DODAJ DO KOSZYKA</a></article></li>';
	          }).join('');
	          syncMore(products.length);
	        }
	        function select(i, keepExpanded) {
	          active = i;
	          if (!keepExpanded) expanded = false;
	          Array.prototype.forEach.call(bar.children, function (b, bi) { b.classList.toggle('on', bi === i); });
	          var c = cats[i];
	          if (!c.h) { restoreNative(); return; }
	          if (cache[c.h]) { render(cache[c.h]); return; }
	          fetch('/collections/' + c.h + '/products.json?limit=12')
	            .then(function (r) { return r.json(); })
	            .then(function (d) { cache[c.h] = d.products || []; render(cache[c.h]); })
	            .catch(restoreNative);
	        }
	        cats.forEach(function (c, i) {
	          var b = el('button', 'evm-xcat' + (i === 0 ? ' on' : ''), c.n);
	          b.type = 'button';
	          b.addEventListener('click', function () { select(i); });
	          bar.appendChild(b);
	        });
	        if (head && head.parentNode) head.parentNode.insertBefore(bar, head.nextSibling);
	        else xsell.insertBefore(bar, xsell.firstChild);
	        select(0);
	      }, 250);
	    })();

    /* 8i2. LENDING „Cechy": 9 sekcji image-with-text → jedna zwarta siatka zdjęć (4 w rzędzie + ostatnie szerokie) */
    (function () {
      return; /* round 5: wracamy do oryginalnego landing layoutu template config */
      var iws = Array.prototype.slice.call(document.querySelectorAll('.image-with-text'));
      var items = [];
      iws.forEach(function (iw) {
        var img = iw.querySelector('.image-with-text__media img, img');
        var h = iw.querySelector('.image-with-text__heading, h2, h3');
        var sec = iw.closest('.shopify-section') || iw;
        if (!img || !h || items.some(function (x) { return x.sec === sec; })) return;
        items.push({ src: img.currentSrc || img.src, title: (h.textContent || '').replace(/^\s*\d+\.\s*/, '').trim(), iw: iw, sec: sec });
      });
      if (items.length < 3) return;
      var host = items[0].sec;
      var grid = el('div', 'evm-cechy', '');
      items.forEach(function (it, idx) {
        var wide = (idx === items.length - 1 && items.length % 2 === 1); /* ostatnie nieparzyste = szerokie */
        /* obraz ma już wypalony tekst → BEZ podpisu pod spodem (żeby nie dublować) */
        var card = el('div', 'evm-fcard' + (wide ? ' evm-fcard--wide' : ''), '');
        card.innerHTML = '<span class="evm-fcard__img"><img loading="lazy" alt=""></span>';
        card.querySelector('img').src = it.src;
        grid.appendChild(card);
      });
      host.insertBefore(grid, host.firstChild);
      /* ważna uwaga z oryginału (jest na foto 5 u właściciela) */
      var note = el('div', 'evm-cechy-note',
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>' +
        '<span><b>Uwaga:</b> wersja 3D z jęzorem nie jest możliwa dla każdego modelu. Prosimy sprawdzić zdjęcie główne — przedstawia ono przykładowy wygląd dywaników dla danego auta.</span>');
      host.insertBefore(note, grid.nextSibling);
      host.insertBefore(el('h2', 'evm-cechy-h', 'Cechy konstrukcji'), grid);
      /* ukryj WSZYSTKIE oryginalne bloki image-with-text (host może mieć własny obok siatki) */
      Array.prototype.forEach.call(document.querySelectorAll('.image-with-text'), function (x) { x.style.display = 'none'; });
      items.forEach(function (it, idx) { if (idx > 0) it.sec.style.display = 'none'; }); /* pozostałe sekcje ukryj całkiem */
    })();

    /* 8j. Krok 1 (rok) 1:1 z makietą: podtytuł + zielony „pasuje" hint */
    (function () {
      var yw = product.querySelector('.product__dropdown_wr[data-dropdown="year"]');
      if (!yw) return;
      var inner = yw.querySelector('.product__dropdown_inner');
      if (!inner || inner.querySelector('.evm-step-sub')) return;
      inner.insertBefore(el('p', 'evm-step-sub', 'Rok produkcji auta — dopasujemy wykrój do Twojej generacji.'), inner.firstChild);
      var fs = inner.querySelector('fieldset');
      var hint = el('div', 'evm-year-hint',
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg>' +
        '<span>Pasuje do <b>' + vehicle + '</b> — dopasowany wykrój dla Twojego auta.</span>');
      /* „Pasuje do" POD polami (po Skrzyni biegów), tuż nad przyciskiem Dalej */
      var yNav = inner.querySelector('.evm-nav-row');
      if (yNav) inner.insertBefore(hint, yNav);
      else if (fs && fs.parentNode) fs.parentNode.insertBefore(hint, fs.nextSibling);
      else inner.appendChild(hint);
    })();

    /* 8L. „Uwagi do zamówienia" → do kroku Akcesoria (ostatni krok) */
    (function () {
      var uw = document.getElementById('uwagi-do-zamowienia');
      var uwField = uw ? uw.closest('.line-item-property__field, p') : null;
      var extras = wrappers[wrappers.length - 1];
      var inner = extras ? extras.querySelector('.product__dropdown_inner') : null;
      if (uwField && inner && !inner.contains(uwField)) {
        uwField.classList.add('evm-uwagi');
        var nav = inner.querySelector('.evm-nav-row');
        if (nav) inner.insertBefore(uwField, nav); else inner.appendChild(uwField);
      }
    })();

    /* 8m. GALERIA — zostawiamy NATYWNĄ (ma sync zdjęć z wariantem + odtwarzanie video),
       dodajemy tylko plakietki + czerwone strzałki; CSS robi jeden kadr (bez „peek") i ładny wygląd. */
    (function () {
      var wrap = product.querySelector('.product-media-gallery-wr') || product.querySelector('.product__media-wrapper');
      if (!wrap || wrap.dataset.evmGal) return;
      wrap.dataset.evmGal = '1';
      wrap.style.position = 'relative';
      if (!wrap.querySelector('.evm-gal-badges')) {
        var badges = el('div', 'evm-gal-badges',
          '<span class="evm-gal-disc">−30%</span>' +
          '<span class="evm-gal-pl"><span class="evm-flag"><i></i><i></i></span>Polski produkt</span>');
        wrap.insertBefore(badges, wrap.firstChild);
      }
      var track = wrap.querySelector('.product__media-list, ul.slider');
      if (track && !wrap.querySelector('.evm-nav')) {
        function nav(dir) {
          var item = track.querySelector('.product__media-item') || track.firstElementChild;
          var w = item ? item.getBoundingClientRect().width : track.getBoundingClientRect().width;
          track.scrollBy({ left: dir * (w + 1), behavior: prefersReduced() ? 'auto' : 'smooth' });
        }
        var svgL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
        var svgR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
        var prev = el('button', 'evm-nav evm-nav-prev', svgL); prev.type = 'button';
        var next = el('button', 'evm-nav evm-nav-next', svgR); next.type = 'button';
        prev.addEventListener('click', function () { nav(-1); });
        next.addEventListener('click', function () { nav(1); });
        wrap.appendChild(prev); wrap.appendChild(next);
	      }
	    })();

	    /* 8j2. Cena główna: stabilny własny pasek, bez nakładania elementów Discount Mixera */
	    function syncDmixerMainPrice() {
	      evmRenderMainPrice();
	    }
	    function safeSyncMainPrice() {
	      try { syncDmixerMainPrice(); } catch (e) { }
	    }
	    [0, 120, 500, 1200, 2400].forEach(function (delay) {
	      setTimeout(safeSyncMainPrice, delay);
	    });
	    document.addEventListener('change', function () { setTimeout(safeSyncMainPrice, 30); }, true);

	    /* 8k. ukryj natywne „wróć do koszyka" na mobilce (pojawia się po dodaniu) */
	    function hideCartReturn() {
      Array.prototype.slice.call(document.querySelectorAll('a,button,div,span')).forEach(function (n) {
        if (n.children.length > 1) return;
        var t = (n.textContent || '').trim().toLowerCase();
        if (t && t.length < 40 && (/wróć do koszyk|powrót do koszyk|wroc do koszyk|kontynuuj zakup/.test(t))) {
          var box = n.closest('.cart-notification, .cart__toast, [class*="cart-return"], [class*="back-to-cart"]') || n;
          box.style.setProperty('display', 'none', 'important');
        }
      });
    }
    hideCartReturn();
    new MutationObserver(hideCartReturn).observe(document.body, { childList: true, subtree: true });

    /* 8n. jeden wspólny „card" konfiguratora (KROK + podgląd + krok + podsumowanie) jak makieta.
       Kroki zostają kolejnymi rodzeństwami → natywny getNextDropdown nadal działa. */
    (function () {
      if (!progress || !progress.parentNode) return;
      var card = el('div', 'evm-cfg-card');
      progress.parentNode.insertBefore(card, progress);
      card.appendChild(progress);
      if (nativePreview) card.appendChild(nativePreview);
      wrappers.forEach(function (w) { card.appendChild(w); });
      card.appendChild(summary);
    })();

    /* 8g. podgląd: widoczny na krokach zestaw/kolor; wymuś render obrazka */
	    var lastPreviewStepKey = '';
	    function syncPreview() {
	      if (!nativePreview) return;
	      var open = openWrapper();
	      var key = open ? stepKey(open) : '';
	      var on = (key === 'mats_set_type' || key === 'mat_patterns_colors');
	      nativePreview.classList.toggle('evm-preview-on', on);
	      if (on) {
	        if (key !== lastPreviewStepKey) {
	          lastPreviewStepKey = key;
	          if (key === 'mat_patterns_colors') {
	            [520, 920, 1280].forEach(function (delay) {
	              setTimeout(function () {
	                var stillOpen = openWrapper();
	                if (stillOpen && stepKey(stillOpen) === 'mat_patterns_colors') scrollToConfig();
	              }, delay);
	            });
	          }
	        }
	        function prettyPreviewText(txt) {
	          var s = (txt || '').replace(/\s+/g, ' ').trim();
	          if (!s) return s;
	          s = s.replace(/^rodzaj\s+dywanik[oó]w:\s*/i, '').replace(/^zestaw:\s*/i, '');
	          if (/^3d\s+bez\s+rant/i.test(s)) return '3D bez rantów';
	          if (/^3d\s+z\s+rant/i.test(s)) return '3D z rantami';
	          if (/3\s*r(z[ąa]d|z[ęe]dy).+2\s*baga/i.test(s)) return '3 rzędy + 2 bagażniki';
	          s = s.replace(/\s*\([^)]*\)\s*$/, '');
	          s = s.replace(/^kolor\s+materia[łl]u:\s*/i, '').replace(/^kolor\s+obszycia:\s*/i, '');
	          return s.toLowerCase().replace(/(^|[\s+/-])([a-ząćęłńóśźż])/g, function (_, p, c) {
	            return p + c.toUpperCase();
	          }).replace(/\s+\+\s+/g, ' + ');
	        }
		        var pat = nativePreview.querySelector('[data-type="matPattern"] span');
		        var patInfo = checkedLabelImg('fieldset[data-type="matPattern"]', 'input[type="radio"]');
		        if (pat) {
		          pat.textContent = prettyPreviewText(patInfo.txt || 'Diamenty');
		        }
		        var patText = ((patInfo.txt || '') + '').toLowerCase();
		        nativePreview.classList.toggle('evm-pattern-krople', /kropl/.test(patText));
		        nativePreview.classList.toggle('evm-pattern-romby', /romb/.test(patText));
		        nativePreview.classList.toggle('evm-pattern-plastry', /plastr|miod/.test(patText));
	        Array.prototype.slice.call(nativePreview.querySelectorAll('.product__config_image_selected_value span')).forEach(function (sp) {
	          sp.textContent = prettyPreviewText(sp.textContent);
	        });
	        function syncChipImage(sel, info) {
	          var chip = nativePreview.querySelector(sel);
	          if (!chip || !info || !info.img) return;
	          var im = chip.querySelector('img.evm-pv-chip-img') || chip.querySelector('img');
	          if (!im) {
	            im = document.createElement('img');
	            im.alt = '';
	            chip.insertBefore(im, chip.querySelector('span'));
	          }
	          Array.prototype.slice.call(chip.querySelectorAll('img')).forEach(function (other) {
	            if (other !== im) other.parentNode.removeChild(other);
	          });
	          im.classList.add('evm-pv-chip-img');
	          if (im.getAttribute('src') !== info.img) im.setAttribute('src', info.img);
	          var sp = chip.querySelector('span');
	          if (sp && info.txt) {
	            sp.textContent = prettyPreviewText(info.txt);
	            var chipKind = chip.dataset.type || chip.dataset.name || '';
	            var longLimit = /matColor|trimColor/.test(chipKind) ? 8 : 22;
	            chip.classList.toggle('evm-chip-long', sp.textContent.length > longLimit);
	          }
	        }
		        var typeInfo = checkedLabelImg('fieldset[data-name="mats_type"]', 'input[type="radio"]');
		        var typeText = ((typeInfo.txt || '') + '').toLowerCase();
		        nativePreview.classList.toggle('evm-preview-bez-rantow', /bez\s+rant/.test(typeText));
		        nativePreview.classList.toggle('evm-preview-z-rantami', /z\s+rant|rantami/.test(typeText) && !/bez\s+rant/.test(typeText));
		        syncChipImage('[data-name="mats_type"]', typeInfo);
		        syncChipImage('[data-name="mats_set"]', checkedLabelImg('fieldset[data-name="mats_set"]', 'input[type="radio"]'));
	        syncChipImage('[data-type="matPattern"]', checkedLabelImg('fieldset[data-type="matPattern"]', 'input[type="radio"]'));
	        syncChipImage('[data-type="matColor"]', checkedLabelImg('fieldset[data-type="matColor"]', 'input[type="radio"]'));
	        syncChipImage('[data-type="trimColor"]', checkedLabelImg('fieldset[data-type="trimColor"]', 'input[type="radio"]'));
	        var img = nativePreview.querySelector('.product__config_image--mobile_image');
	        if (img && /1x1_0{4,}/.test(img.src || '')) {
	          var trig = product.querySelector('fieldset[data-type="matColor"] input:checked') ||
	                     product.querySelector('fieldset[data-type="matPattern"] input:checked');
	          if (trig) trig.dispatchEvent(new Event('change', { bubbles: true }));
	        }
	        if (img) {
	          var src = img.currentSrc || img.src || '';
	          if (src && !/1x1_0{4,}/.test(src)) {
	            lastPreviewImg = src;
	          } else if (lastPreviewImg) {
	            img.removeAttribute('srcset');
	            img.setAttribute('src', lastPreviewImg);
	          } else {
	            var fallbackInfo = checkedLabelImg('fieldset[data-name="mats_type"]', 'input[type="radio"]');
	            if (fallbackInfo.img) {
	              img.removeAttribute('srcset');
	              img.setAttribute('src', fallbackInfo.img);
	            }
	          }
	        }
	      } else {
	        lastPreviewStepKey = '';
      }
    }

    /* 8h. dodawanie do koszyka (ukryty natywny submit) */
    function addToCart() {
      var sub = product.querySelector('.product-form__submit');
      if (sub) { sub.click(); return; }
      var f = product.querySelector('form[action*="/cart/add"], product-form form');
      if (f) { f.requestSubmit ? f.requestSubmit() : f.submit(); }
    }

    /* ---------- 7. synchronizacja ---------- */
	    function syncAll() { syncBuybar(); syncShip(); syncSummary(); syncProgress(); syncPreview(); syncDmixerMainPrice(); wizardGuard(); }
	    product.addEventListener('change', function () { setTimeout(syncAll, 40); }, true);
	    var mo = new MutationObserver(function () { syncAll(); });
	    wrappers.forEach(function (w) { mo.observe(w, { attributes: true, attributeFilter: ['class'] }); });
	    if (priceSrc) mo.observe(priceSrc, { childList: true, characterData: true, subtree: true });
	    var mainPrice = product.querySelector('.main_price') || document.querySelector('.main_price');
	    if (mainPrice) {
	      new MutationObserver(function () { setTimeout(syncDmixerMainPrice, 20); })
	        .observe(mainPrice, { childList: true, characterData: true, subtree: true });
	    }
	    syncAll();
	    setTimeout(syncAll, 600);
	    document.addEventListener('evamats:discount-updated', function () { setTimeout(syncDmixerMainPrice, 50); });
	    setTimeout(setTabsTop, 600);

    /* DEBUG (tylko z ?evmflow=N): auto-przejście kroków do zrzutów ekranu.
       USUNĄĆ przy porcie na LIVE. */
    var mFlow = location.search.match(/evmflow=(\d)/);
    if (mFlow) {
      var flowTo = +mFlow[1];
      var clickDalej = function (w) {
        var b = w && w.querySelector('.product__dropdown_button');
        if (b) b.click();
      };
      /* odporny na resety motywu: powtarzaj aż krok dostanie .complete */
      var driveStep = function (idx, prep, next) {
        var tries = 0;
        var iv = setInterval(function () {
          var w = wrappers[idx];
          if (!w) { clearInterval(iv); return; }
          if (w.classList.contains('complete') || tries++ > 10) {
            clearInterval(iv);
            if (next) next();
            return;
          }
          try { prep(w); } catch (e) {}
          clickDalej(w);
        }, 650);
      };
      setTimeout(function () {
        var prepYear = function () {
          var yearSel = product.querySelector('#rok-produkcji');
          if (yearSel && yearSel.options.length > 1 && !yearSel.value) {
            yearSel.selectedIndex = yearSel.options.length - 1;
            yearSel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };
        var prepSet = function (w) {
          ['mats_type', 'mats_set'].forEach(function (nm) {
            var fs = w.querySelector('fieldset[data-name="' + nm + '"]');
            if (fs && !fs.querySelector('input:checked')) {
              var f = fs.querySelector('input[type="radio"]');
              if (f) { f.checked = true; f.dispatchEvent(new Event('change', { bubbles: true })); }
            }
          });
        };
        if (flowTo === 2) { driveStep(0, prepYear, null); return; }
        if (flowTo === 3) {
          driveStep(0, prepYear, function () {
            driveStep(1, prepSet, function () {
              setTimeout(function () { syncAll(); scrollToConfig(); }, 180);
            });
          });
          return;
        }
        if (flowTo === 4 || flowTo === 5) {
          driveStep(0, prepYear, function () {
            driveStep(1, prepSet, function () {
              driveStep(2, function () {}, function () {
                /* po kolorze natywny Dalej otwiera krok 4 (podpiętki) — flow=4 tu stop */
                if (flowTo === 5) setTimeout(function () {
                  var b = wrappers[3] && wrappers[3].querySelector('.evm-next'); if (b) b.click(); /* → krok 5 */
                }, 900);
              });
            });
          });
          return;
        }
        if (flowTo >= 9) {
          driveStep(0, prepYear, function () {
            driveStep(1, prepSet, function () {
              driveStep(2, function () {}, function () {
                setTimeout(function () {
                  var b4 = wrappers[3] && wrappers[3].querySelector('.evm-next');
                  if (b4) b4.click();
                  setTimeout(function () {
                    var b5 = wrappers[4] && wrappers[4].querySelector('.evm-next');
                    if (b5) b5.click();
                  }, 900);
                }, 900);
              });
            });
          });
        }
      }, 2400);
    }

    /* DEBUG (tylko z ?evmdebug=1): wypisz elementy szersze niż viewport do <title> */
    if (/evmdebug/.test(location.search)) {
      setTimeout(function () {
        var w = window.innerWidth, list = [];
        document.querySelectorAll('body *').forEach(function (n) {
          var r = n.getBoundingClientRect();
          if (r.right > w + 2 && r.width > 40) {
            list.push(n.tagName + '.' + String(n.className && n.className.baseVal !== undefined ? n.className.baseVal : n.className).slice(0, 44) + '>' + Math.round(r.right));
          }
        });
        var sb = document.querySelector('.sticky_container .sticky_add_to_cart');
        var sbInfo = 'noBtn';
        if (sb) {
          var cs = getComputedStyle(sb), r2 = sb.getBoundingClientRect();
          sbInfo = 'btn[d=' + cs.display + ',o=' + cs.opacity + ',v=' + cs.visibility + ',pos=' + cs.position +
            ',w=' + Math.round(r2.width) + ',h=' + Math.round(r2.height) + ',x=' + Math.round(r2.left) + ',y=' + Math.round(r2.top) + ',z=' + cs.zIndex + ',bg=' + cs.backgroundColor + ']';
          var pc = getComputedStyle(sb.parentElement), pr = sb.parentElement.getBoundingClientRect();
          sbInfo += ' cont[d=' + pc.display + ',o=' + pc.opacity + ',w=' + Math.round(pr.width) + ',x=' + Math.round(pr.left) + ',y=' + Math.round(pr.top) + ']';
        }
        var fixed = [];
        document.querySelectorAll('body *').forEach(function (n) {
          var cs = getComputedStyle(n);
          if (cs.position !== 'fixed') return;
          var r = n.getBoundingClientRect();
          if (r.width < 20 || r.width > window.innerWidth - 20) return;
          if (r.bottom < window.innerHeight - 220) return;
          var id = n.id ? '#' + n.id : '';
          var cls = (typeof n.className === 'string' ? n.className : '').split(' ')[0];
          fixed.push((n.tagName + id + (cls ? '.' + cls : '')).slice(0, 40) + '@' + Math.round(r.left) + ',' + Math.round(r.top));
        });
        var pv = document.querySelector('.evm-preview');
        var pvInfo = 'noPreview';
        if (pv) {
          var pcs = getComputedStyle(pv);
          pvInfo = 'PV[cls=' + pv.className.replace('product__config_image--main product__config_image--mobile', '…') + ',disp=' + pcs.display + ',pos=' + pcs.position + ']';
        }
        var colStep = document.querySelector('.product__dropdown_wr[data-dropdown="mat_patterns_colors"]');
        pvInfo += ' colOpen=' + (colStep ? colStep.classList.contains('open') : '?');
        var h1s = Array.prototype.slice.call(document.querySelectorAll('h1'));
        var h1info = h1s.map(function (h) {
          return (h.className || '?').slice(0, 16) + '=' + (h.textContent || '').trim().slice(0, 22) + (product.contains(h) ? '[inProd]' : '[out]');
        }).join(' ║ ');
        var bl = document.querySelector('.evm-bb-label');
        var sb = document.querySelector('.sticky_add_to_cart');
        var svg = sb && sb.querySelector('svg');
        var uw = document.getElementById('uwagi-do-zamowienia');
        var uwIn = uw ? !!uw.closest('.product__dropdown_wr') : null;
        /* łańcuch najszerszego elementu w kroku 2 (diagnoza przepełnienia) */
        var scope2 = document.querySelector('.product__dropdown_wr[data-dropdown="mats_set_type"]') || product;
        var widest = null, wr = -1;
        scope2.querySelectorAll('*').forEach(function (n) { var r = n.getBoundingClientRect(); if (r.width > 30 && r.right > wr) { wr = r.right; widest = n; } });
        var chain = [];
        for (var e = widest; e && e !== document.body; e = e.parentElement) {
          var r = e.getBoundingClientRect();
          chain.push((e.tagName + '.' + ((typeof e.className === 'string' ? e.className : '') || '').split(' ')[0]).slice(0, 24) + '[' + Math.round(r.left) + '→' + Math.round(r.right) + ']');
        }
        document.title = 'EVMDBG|vw=' + window.innerWidth + '|wide=' + (list.join(',') || 'none') + '|CHAIN ' + chain.join(' < ');
      }, 10500);
    }
  });
})();
